module.exports = __webpack_public_path__ + "img/code.71661522.png";